module.exports = __webpack_public_path__ + "static/screen-jet2.dee440d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/screen-jet2.jpg
// module id = 414
// module chunks = 114276838955818